/** Match backend: either treks or treks_manage grants full trek edit UI. */
export function expandTrekWritePermissions(perms) {
  if (!Array.isArray(perms) || perms.includes('*')) return perms || [];
  const set = new Set(perms);
  if (set.has('treks_manage') || set.has('treks')) {
    set.add('treks');
    set.add('treks_manage');
  }
  return Array.from(set);
}

export function canManageTreks(permissions) {
  if (!Array.isArray(permissions)) return false;
  return (
    permissions.includes('*') ||
    permissions.includes('treks_manage') ||
    permissions.includes('treks')
  );
}
